module.exports = __webpack_public_path__ + "static/rigo-and-lauren.b0920b4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/avatars/rigo-and-lauren.jpg
// module id = 284
// module chunks = 168707334958949